export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 30;
export const USERNAME_PATTERN = /^[a-z0-9_]{3,30}$/;

export const RESERVED_USERNAMES = new Set([
  'admin',
  'api',
  'app',
  'auth',
  'changelog',
  'create',
  'data_deletion',
  'facebook',
  'frienzzi',
  'home',
  'install',
  'legal',
  'login',
  'me',
  'mission',
  'notifications',
  'post',
  'posts',
  'privacy',
  'profile',
  'refund_policy',
  'settings',
  'sign_in',
  'sign_up',
  'signup',
  'support',
  'terms',
  'user',
  'users',
  'www',
]);

export function normalizeUsernameInput(value: string) {
  return value.trim().toLowerCase();
}

export function usernameValidationMessage(value: string) {
  const username = normalizeUsernameInput(value);

  if (!username) {
    return 'Choose a username.';
  }

  if (username !== value.trim()) {
    return 'Usernames must use lowercase letters, numbers, and underscores.';
  }

  if (
    username.length < USERNAME_MIN_LENGTH ||
    username.length > USERNAME_MAX_LENGTH
  ) {
    return 'Usernames must be 3 to 30 characters.';
  }

  if (!USERNAME_PATTERN.test(username)) {
    return 'Use only lowercase letters, numbers, and underscores.';
  }

  if (RESERVED_USERNAMES.has(username)) {
    return 'That username is reserved.';
  }

  return null;
}

export function isValidUsername(value: string) {
  return usernameValidationMessage(value) === null;
}
